import { Component, OnInit, Inject } from '@angular/core';
import { Travel } from 'src/app/models/travel';
import { FormGroup, FormBuilder } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material';
import { TravelCashService } from '../../services/travel-cash/travel-cash.service';
import { NotifyboxComponent } from 'src/app/modules/shared/components/notifybox/notifybox.component';

@Component({
  selector: 'app-travel-cash-advance-cancel',
  templateUrl: './travel-cash-advance-cancel.component.html',
  styleUrls: ['./travel-cash-advance-cancel.component.scss']
})
export class TravelCashAdvanceCancelComponent implements OnInit {

  _travel: Travel;
  formGroup: FormGroup;
  loading:boolean;

  constructor(
    public dialogRef: MatDialogRef<TravelCashAdvanceCancelComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public travelCashService: TravelCashService,
    private formBuilder: FormBuilder,
    public dialog: MatDialog
  ) { }

  ngOnInit() {
    this._travel = new Travel('');
    this.formGroup = this.formBuilder.group({
      status: ['',null],
      reason:['',null],
    });
  }

  
  closeOnClick() {
    this.dialogRef.close('');
  }

  save(){
    this.loading = true;
    if (this.data.status == undefined) {
      this.formGroup.controls['status'].setValue("Cancelled");
      this.travelCashService.updateStatus(this.data.id,this.formGroup.value).subscribe(res=>{
        this.loading = false;
        this.dialog.open(NotifyboxComponent , {
          disableClose:true,
          data: {
            reload:false,
            label:'Ok',
            isclose:true,
            message: res['message']
          }
        }).afterClosed().subscribe(result => {
          if (result) {
            this.dialogRef.close(res['data'].data);
          }
        });

      });
    } else {
      let status = "";
      if (this.data.status == 3) {
        status = "Approved";
      } else if (this.data.status == 4) {
        status = "Rejected";
      } else if (this.data.status == 6) {
        status = "Push Back";
      }
      this.formGroup.controls['status'].setValue(status);
      this.travelCashService.approverUpdateStatus(this.data.id,this.formGroup.value).subscribe(res=>{
        this.loading = false;
        
        this.dialog.open(NotifyboxComponent , {
          disableClose:true,
          data: {
            reload:false,
            label:'Ok',
            isclose:true,
            message: res['message']
          }
        }).afterClosed().subscribe(result => {
          if (result) {
            this.dialogRef.close(this.formGroup.value);
          }
        });
      });
    }
  }


}
